import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {Button, Form, Image, Input, Toast} from "antd-mobile";
import {userLogin} from "../../common/ApiAction";
import {TOASTDURATION} from "../../common/Utils";

const UserLogin = () => {
    const navigate = useNavigate()
    const { t } = useTranslation();

    const onFinish = (values: any) => {
        Toast.show({icon: 'loading', content: 'Login...', duration: 0})
        userLogin(values).then((res: any) => {
            Toast.clear();
            if (!res.executed) {
                Toast.show({icon: 'fail', content: res.message, duration: TOASTDURATION})
            } else {
                navigate('/user/orderList', {state: {mobile: values.mobile, originalPassword: res.data.originalPassword, userInfoId: res.data.userInfoId}})
            }
        }).catch(err => {
            Toast.clear();
            Toast.show({icon: 'fail', content: err.message, duration: TOASTDURATION})
        })
    }

    return <div style={{backgroundColor: '#F5F6FA', height: '100vh', display: "flex", flexDirection: "column", padding: '0 12px', justifyContent: "center", textAlign: "center"}}>
        <div style={{display: "flex", flexDirection: "column", alignItems: "center", marginBottom: 25}}>
            <Image src={require('../../assets/icon_ego_logo.jpg')}/>
        </div>
        <Form
            onFinish={onFinish}
            mode={'card'}
            layout='horizontal'
            footer={<Button shape='rounded' block type='submit' color='primary' size='middle'>{t('submit')}</Button>}>
            <Form.Header>{t('user_login_title')}</Form.Header>
            <Form.Item name='mobile' rules={[{ required: true, message: t('user_mobile_placeholder') }]}>
                <Input type={"number"} placeholder={t('user_mobile_placeholder')} />
            </Form.Item>
            <Form.Item name='password' rules={[{ required: true, message: t('user_password_placeholder') }]}>
                <Input placeholder={t('user_password_placeholder')} />
            </Form.Item>
        </Form>
    </div>
}
export  default UserLogin
